import { getScore } from '../common/scoreHelpers';
import { sortFixNoFixScore } from '../common/sortScoreHelpers';
import { useMemo } from 'react';
import { getVulnerabilityScore, useGetVulnerabilities } from '@internal/backstage-plugin-zf-vulnerabilities';
import { ScoreIndex, ScoreWithFixAndNoFix } from '@internal/ui-common';
import { Team, VulnerabilityItem } from '@internal/schemas-common';

type UseGetScoresProps = {
  teams: Team[];
};

type UseGetScoresResult = {
  scores: ScoreIndex<ScoreWithFixAndNoFix>[] | undefined;
};

function getTeamFromVulnerability(vul: VulnerabilityItem): string {
  return vul.team.toLowerCase();
}

export const useGetVulnerabilitiesScores = ({
  teams,
}: UseGetScoresProps): UseGetScoresResult => {
  const { vulnerabilities, loading } = useGetVulnerabilities({
    teams: teams
  });

  const scores = useMemo(() => {
    return getScore<VulnerabilityItem, ScoreWithFixAndNoFix>(
      loading,
      teams,
      vulnerabilities,
      {
        getTeam: getTeamFromVulnerability,
        getScore: getVulnerabilityScore,
        sortScore: sortFixNoFixScore,
      },
    );
  }, [vulnerabilities, teams, loading]);

  return { scores: scores };
};
